import React, { createContext, useContext, useMemo } from "react";
import { useSelector } from "react-redux";

const FeatureFlagContext = createContext(null);

export function FeatureFlagProvider({ children }) {
    const { isStaff, userPermissions } = useSelector((state) => state.auth);

    // Convert permission array → lookup map
    const permissionMap = useMemo(() => {
        const map = {};

        userPermissions?.forEach((item) => {
            const key = Object.keys(item)[0];   // "Patient", "ViewingTheCatalogue", etc.
            const value = item[key];            // "read" | "create" | "manage"

            // convert into feature-style flags
            if (value === "read") {
                map[`${key}.read`] = true;
            }

            if (value === "create") {
                map[`${key}.create`] = true;
            }

            if (value === "manage") {
                // manage = full access
                map[`${key}.read`] = true;
                map[`${key}.create`] = true;
                map[`${key}.manage`] = true;
            }
        });

        return map;
    }, [userPermissions]);


    const hasFeature = (feature) => {
        // Practice users = all features
        if (!isStaff) return true;

        // Staff → check permission map
        return !!permissionMap[feature];
    };


    return (
        <FeatureFlagContext.Provider value={{ hasFeature }}>
            {children}
        </FeatureFlagContext.Provider>
    );
}

export const useFeatureFlag = () => useContext(FeatureFlagContext);
